module.exports = __webpack_public_path__ + "img/Sjian.109b950a.svg";